import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import { SEARCH_INDEX_DELAY } from '../../consts';
import AI_UPDATE_PROMPT from '../mutations/AI_UPDATE_PROMPT';
  
const useAIUpdatePrompt = () => {
    const [ isSaving, setIsSaving ] = useState( false );
    const [ updateMutation ] = useMutation( AI_UPDATE_PROMPT );

    const handleUpdatePrompt = async ( variables, onFinishCallback ) => {
        setIsSaving( true );
        
        try {
            await updateMutation( { variables: { input: { ...variables } } } );
            
            setTimeout( () => {
                if ( onFinishCallback ) { onFinishCallback(); }
                setIsSaving( false );
            }, SEARCH_INDEX_DELAY );
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error updating prompt!' );
            setIsSaving( false );
        }
    };

    return useMemo( () => {
        return {
            isSaving,
            updatePrompt: handleUpdatePrompt
        };
    }, [ isSaving ] );
};

export default useAIUpdatePrompt;
